import { mobileBreakpoint } from "../components/shared/constants";

const smMedia = (style) => {
  return `@media screen and (max-width: ${mobileBreakpoint}){
    ${style}
  }`;
};

export { smMedia };
